import React, { useState, useEffect } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

// material-ui
import Box from "@mui/material/Box";

import { Request_Get_Registers_Fuzzy_Search } from "../../Registers/api/Request_Get_Registers_Fuzzy_Search";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { api_Send_SXPREACHEmail_ToParents } from "./api/api_Send_SXPREACHEmail_ToParents";
import { Request_Get_REACHCOntactsWhoNeedEmail } from "./api/Request_Get_REACHCOntactsWhoNeedEmail";

function SXPREACHEmailToParents() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------
  // Assuming you have a state to store the fetched data
  const [Registers, setRegisters] = useState([]);
  //Load those who may need an email
  useEffect(() => {
    Request_Get_REACHCOntactsWhoNeedEmail({}, setRegisters, logout);
  }, []);

  const determineDueEmail = (customer) => {
    const notes = customer.Notes || [];
    if (notes.length === 0) {
      return true;
    }
    const emailNotes = notes.filter((note) =>
      ["REACH Email Sent"].includes(note.Note)
    );
    if (emailNotes.length === 0) {
      return true;
    }
    return false;
  };

  function handleSend(e, chosenArray) {
    e.preventDefault();

    const PersonsToSend = chosenArray.filter((Person) =>
      determineDueEmail(Person)
    );

    PersonsToSend.forEach((Person) => {
      console.log("Person");
      api_Send_SXPREACHEmail_ToParents({ Person: Person }, logout);
      console.log("REACH Email Sent");
    });
    console.log("-----End Send-----");
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Send REACH Email To Parents
          </Typography>
          <button
            style={{ width: "100px" }}
            onClick={(e) => handleSend(e, Registers)}
          >
            Send
          </button>

          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <>{SimpleTableHeader("Email")}</>
                  <>{SimpleTableHeader("REACH ContactID")}</>
                  <>{SimpleTableHeader("Send")}</>
                </TableRow>
              </TableHead>
              <TableBody>
                {Registers.map((Person, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Person?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : Person?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Person?.MetaData?.Bursary === "Yes"
                          ? "rgba(144, 238, 144, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    {SimpleTableCell(Person.Email)}
                    {SimpleTableCell(Person.ContactID)}
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {determineDueEmail(Person) ? (
                        <button onClick={(e) => handleSend(e, [Person])}>
                          Send
                        </button>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default SXPREACHEmailToParents;
